import { mapGetters } from 'vuex'
import io from 'socket.io-client'
import dayjs from 'dayjs'
import config from '@/config'
export default {
  props: ['value', 'timestamp'],
  data() {
    return {
      pagelistHeight: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist'
    }),
    optionBotlist: function() {
      return this.botlist
        .map(el => {
          var isLock = !(
            (el.pagetype == 'enterprise' &&
              this.$store.state.livechatPageList.includes(el.theme)) ||
            this.$store.state.livechatPageIdList.includes(el.pageid) ||
            (el.theme == 'ecommercebasic' && el.pageid == '270028443161479') ||
            el.isUnlockLivechat
          )
          return {
            name: el.pagename,
            value: el.pageid,
            line_modular_botid: el.line_modular_botid,
            pagelogo: el.pagelogo,
            isLock: isLock,
          }
        })
        .filter(el => {
          return el != null
        })
        .sort((a, b) => {
          var nameA = a.name.toUpperCase() // ignore upper and lowercase
          var nameB = b.name.toUpperCase() // ignore upper and lowercase
          if (nameA < nameB) {
            return -1
          }
          if (nameA > nameB) {
            return 1
          }

          // names must be equal
          return 0
        })
    }
  },
  async mounted() {
    const vm = this
    await this.$nextTick()
    if (this.$el.querySelector(`#bot_${this.value}`)) {
      this.$el.querySelector(`#bot_${this.value}`).scrollIntoView()
    }

    if (vm.$store.state.SOCKET_GROUP_GT817.includes(vm.$store.state.livechat.pageid)) {
      vm.socket = io(config.socketUrl, {
        transports: ['websocket']
      })

      vm.socket.on('connect', () => {
        vm.socket.emit('join-room', 'gt817', error => {
          if (error) {
            console.log(`join-room error`, error)
          }
          console.log('[socket connected]: ', vm.socket.connected)
        })
      })
      vm.socket.on('disconnect', reason => {
        console.log('[socket disconnected]: ', reason)
      })
      vm.socket.on('connect_error', error => {
        console.error('[connect error]: ', error)
      })

      vm.socket.on(`livechat:getuserthread:U85a89e2bf0d80a0ebe0d7f6439225502`, message => {
        vm.getuserthread('U85a89e2bf0d80a0ebe0d7f6439225502', message)
      })
      vm.socket.on(`livechat:adminreadchat:U85a89e2bf0d80a0ebe0d7f6439225502`, message => {
        vm.adminreadchat('U85a89e2bf0d80a0ebe0d7f6439225502', message)
      })

      vm.socket.on(`livechat:getuserthread:Uba55b7ccbeb5ac86a4927cab1eb70799`, message => {
        vm.getuserthread('Uba55b7ccbeb5ac86a4927cab1eb70799', message)
      })
      vm.socket.on(`livechat:adminreadchat:Uba55b7ccbeb5ac86a4927cab1eb70799`, message => {
        vm.adminreadchat('Uba55b7ccbeb5ac86a4927cab1eb70799', message)
      })

      vm.socket.on(`livechat:getuserthread:Ub6e3b0b1eb303bd76e5df2e025185fff`, message => {
        vm.getuserthread('Ub6e3b0b1eb303bd76e5df2e025185fff', message)
      })
      vm.socket.on(`livechat:adminreadchat:Ub6e3b0b1eb303bd76e5df2e025185fff`, message => {
        vm.adminreadchat('Ub6e3b0b1eb303bd76e5df2e025185fff', message)
      })

      vm.socket.on(`livechat:getuserthread:U4a257dc7bdc83475caa1e3d0659eeed8`, message => {
        vm.getuserthread('U4a257dc7bdc83475caa1e3d0659eeed8', message)
      })
      vm.socket.on(`livechat:adminreadchat:U4a257dc7bdc83475caa1e3d0659eeed8`, message => {
        vm.adminreadchat('U4a257dc7bdc83475caa1e3d0659eeed8', message)
      })

      vm.socket.on(`livechat:getuserthread:U0071eeda6f9d41e415006d7c27e25caf`, message => {
        vm.getuserthread('U0071eeda6f9d41e415006d7c27e25caf', message)
      })
      vm.socket.on(`livechat:adminreadchat:U0071eeda6f9d41e415006d7c27e25caf`, message => {
        vm.adminreadchat('U0071eeda6f9d41e415006d7c27e25caf', message)
      })

      vm.socket.on(`livechat:getuserthread:Ubbd3e2e70ad8339424fc35121a98903a`, message => {
        vm.getuserthread('Ubbd3e2e70ad8339424fc35121a98903a', message)
      })
      vm.socket.on(`livechat:adminreadchat:Ubbd3e2e70ad8339424fc35121a98903a`, message => {
        vm.adminreadchat('Ubbd3e2e70ad8339424fc35121a98903a', message)
      })

      vm.getCustomPageNotiChat()
    }
  },
  destroyed() {
    const vm = this
    vm.socket.disconnect()
  },
  methods: {
    adminreadchat(pageId, message) {
      console.log(message)
      const vm = this
      vm.$store.state.livechat.users_unread[pageId][message.userid || message.group_id] = 0
      if (vm.$store.state.countAllNotiCustom[pageId] > 0) {
        vm.$store.state.countAllNotiCustom[pageId] = vm.$store.state.countAllNotiCustom[pageId] - 1
      }
      vm.$emit('update:timestamp', dayjs().format('x'))
    },
    getuserthread(pageId, message) {
      const vm = this
      if (
        typeof vm.$store.state.livechat.users_unread[pageId][message.userid || message.group_id] ===
        'undefined'
      ) {
        vm.$store.state.livechat.users_unread[pageId][message.userid || message.group_id] = 0
      }

      if (vm.$store.state.livechat.users_unread[pageId][message.userid || message.group_id] === 0) {
        vm.$store.state.countAllNotiCustom[pageId] = vm.$store.state.countAllNotiCustom[pageId] + 1
        console.log(vm.$store.state.countAllNotiCustom[pageId])
      }
      vm.$emit('update:timestamp', dayjs().format('x'))
      vm.$store.state.livechat.users_unread[pageId][message.userid || message.group_id] = 1
    },
    getCustomPageNotiChat() {
      const vm = this
      const SOCKET_GROUP_GT817 = vm.$store.state.SOCKET_GROUP_GT817
      vm.botlist.forEach(async element => {
        if (SOCKET_GROUP_GT817.includes(element.pageid)) {
          let response = await vm.get(`v2/livechatnotiunread?pageid=${element.pageid}`, {
            custom_url: config.serverUrlAws
          })
          if (response.data && response.data.length > 0) {
            const countAllNoti =
              parseInt(response.data[0].facebook_admin || 0) +
              parseInt(response.data[0].facebook_bot || 0) +
              parseInt(response.data[0].instagram_admin || 0) +
              parseInt(response.data[0].instagram_bot || 0) +
              parseInt(response.data[0].line_admin || 0) +
              parseInt(response.data[0].line_bot || 0) +
              parseInt(response.data[0].line_group_bot || 0) +
              parseInt(response.data[0].line_group_admin || 0) +
              parseInt(response.data[0].google_admin || 0) +
              parseInt(response.data[0].google_bot || 0) +
              parseInt(response.data[0].whatsapp_admin || 0) +
              parseInt(response.data[0].whatsapp_bot || 0)

            vm.$store.state.countAllNotiCustom[element.pageid] = countAllNoti
            vm.$store.state.livechat.users_unread[element.pageid] =
              response.data && response.data.length > 0 && response.data[0].user_obj
                ? response.data[0].user_obj
                : {}
          }
        }
      })
    },
    onError: function(event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },
    selectPage(pageID, lineModularBotID) {
      this.$store.commit('SELECT_PAGE_LIVECHAT', { pageID, lineModularBotID })
      this.$emit('changePage', pageID)
    },
    async onResizeToolList() {
      await this.$nextTick()
      this.pagelistHeight =
        window.innerHeight - document.getElementById('main_toolbar').clientHeight
    }
  },
  watch: {
    value(newVal) {
      if (newVal && this.$el.querySelector(`#bot_${newVal}`)) {
        this.$el.querySelector(`#bot_${newVal}`).scrollIntoView()
        this.$store.dispatch('forceLoadLastestUsers').then(() => {})
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/view/livechat/LivechatPagelist.js